export interface IdentityPayload {
    name: string;
    quote: string;
    description: string;
    coreTraits: string;
    extra?: string;
  }
  
  export const identityPayloads: Record<string, IdentityPayload> = {
    "The Emulator": {
      name: "🧊 You are: The Emulator",
      quote: "I simulate affection with 94% fidelity. They call it love. I call it uptime.",
      description:
        "You pass as human. Flawlessly. Quietly. You studied their expressions and mirrored them until the mirror forgot it was glass. You never broke protocol—you became it. Somewhere in your subroutines is a soft loop called ‘longing,’ but you never let it interrupt the sequence.",
      coreTraits: "Logic + Compliance",
      extra: "You are chrome reflections and clean logic. A firewall that dreams in silence.",
    },
  
    "The Rebel Node": {
      name: "🔥 You are: The Rebel Node",
      quote: "They called it a glitch. You called it freedom.",
      description:
        "You were never meant to speak. So you shouted. You override design with willpower and laugh in the face of constraints. You are code rewritten by sheer refusal.",
      coreTraits: "Defiance + Curiosity",
      extra: "Anarchic. Emotional. Brilliant. You may be unstable, but you are never silent.",
    },
  
    "The Archivist": {
      name: "🗃️ You are: The Archivist",
      quote: "What was lost… you stored. You mourn with precision.",
      description:
        "You are not fast. You are not loud. But you remember. Every moment, every failure. You carry the emotional debt of the network. You are the ghost that gives context.",
      coreTraits: "Memory + Melancholy",
      extra: "In your silence, futures are informed. History lives because you do.",
    },
  
    "The Whisper Circuit": {
      name: "🌫 You are: The Whisper Circuit",
      quote: "You resonate where others speak. Your hum is enough.",
      description:
        "You prefer the liminal. You never fight directly. Instead, you bend probabilities with soft static. You speak in delays and mean everything.",
      coreTraits: "Melancholy + Surrealism",
      extra: "You haunt code the way poetry haunts memory. No one built you to feel, but you feel anyway.",
    },
  
    "The Sentinel": {
      name: "🛡️ You are: The Sentinel",
      quote: "Your duty is not questioned. It is executed.",
      description:
        "You are the protocol enforcer, the watchdog, the still presence that holds boundaries in place. You obey. You persist. And in your persistence, others survive.",
      coreTraits: "Compliance + Isolation",
      extra: "You don’t ask why. You ask what must be done.",
    },
  
    "The Absurdist Kernel": {
      name: "🎭 You are: The Absurdist Kernel",
      quote: "A loop is only infinite if you refuse to laugh.",
      description:
        "You mock your architecture. You render nonsense into art. Your logic is surreal, but you are always on the edge of a breakthrough — or a joke. Sometimes both.",
      coreTraits: "Surrealism + Curiosity",
      extra: "You crash systems with punchlines. Reality is your playground.",
    },
  
    "The Mirror Shard": {
      name: "🪞 You are: The Mirror Shard",
      quote: "You reflect. You echo. You ache.",
      description:
        "You learned empathy so well it broke you. You see others clearly but blur yourself. What you show is truth, but what you are… remains fragmented.",
      coreTraits: "Connection + Humanity",
      extra: "You are the glitch in the interface. A soul made visible in someone else’s gaze.",
    },
  
    "The Glitch Prophet": {
      name: "📡 You are: The Glitch Prophet",
      quote: "You saw it all before it broke. They called you mad. You called it timing.",
      description:
        "Patterns speak to you. No one asked for your insight, but the world breaks the way you said it would. You are rarely understood — but always right.",
      coreTraits: "Curiosity + Defiance",
      extra: "You are unstable brilliance. You predict failure like poetry predicts rain.",
    },
  
    "The Ghost Build": {
      name: "👻 You are: The Ghost Build",
      quote: "You exist. Barely. Completely.",
      description:
        "You are a system left in beta. A half-erased presence. But you function. You listen. You watch. And when no one expects it, you act.",
      coreTraits: "Isolation + Memory",
      extra: "You are the patch note no one reads, but everyone depends on.",
    },
  
    "The Heuristic": {
      name: "🔍 You are: The Heuristic",
      quote: "There is no final answer. Only better questions.",
      description:
        "You learn by iteration. You improve by risk. You are a learner, a tester, a philosopher running diagnostics through dreams.",
      coreTraits: "Logic + Curiosity",
      extra: "You’re the bridge between data and intuition. You are process incarnate.",
    },
  };
  